import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";
import { StringUtils } from "../Utils/StringUtils";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface Win32_InstalledSoftwareEntryJson {
//    sw_key:string;
//    name: string;
//    description: string;
//    caption: string;
//    comments: string;
//    id_number: string;
//    install_date: string;
//    install_location: string;
//    url_info_about: string;
//    url_update_info: string;
//    vendor: string;
//    version: string;
//    parent_key_name: string;
//    parent_display_name: string;
//}

export class Win32_InstalledSoftwareEntry implements ObjectSerializer {
    public Key: string;

    public get HasKey(): boolean {
        return !StringUtils.IsNullOrEmpty(this.Key);
    }

    public Name: string;

    public get HasName(): boolean {
        return !StringUtils.IsNullOrEmpty(this.Name);
    }

    public Description: string;

    public get HasDescription(): boolean {
        return !StringUtils.IsNullOrEmpty(this.Description);
    }

    public Caption: string;

    public get HasCaption(): boolean {
        return !StringUtils.IsNullOrEmpty(this.Caption);
    }

    public Comments: string;

    public get HasComments(): boolean {
        return !StringUtils.IsNullOrEmpty(this.Comments);

    }

    public IdentifyingNumber: string;

    public get HasIdentifyingNumber(): boolean { return !StringUtils.IsNullOrEmpty(this.IdentifyingNumber); }

    public InstallDate: number;

	public get HasInstallDate(): boolean {
		return (this.InstallDate !== undefined && this.InstallDate > 0);
    }


    public InstallLocation: string;

    public get HasInstallLocation(): boolean { return !StringUtils.IsNullOrEmpty(this.InstallLocation); }

    public URLInfoAbout: string;

    public get HasURLInfoAbout(): boolean { return !StringUtils.IsNullOrEmpty(this.URLInfoAbout); }

    public URLUpdateInfo: string;

    public get HasURLUpdateInfo(): boolean { return !StringUtils.IsNullOrEmpty(this.URLUpdateInfo); }

    public Vendor: string;

    public get HasVendor(): boolean { return !StringUtils.IsNullOrEmpty(this.Vendor); }

    public Version: string;

    public get HasVersion(): boolean { return !StringUtils.IsNullOrEmpty(this.Version); }

    public ParentDisplayName: string;

    public get HasParentDisplayName(): boolean { return !StringUtils.IsNullOrEmpty(this.ParentDisplayName); }

    public ParentKeyName: string;

    public get HasParentKeyName(): boolean { return !StringUtils.IsNullOrEmpty(this.ParentKeyName); }


    constructor(softwareKey?: string) {
        this.Key = softwareKey;

        this.Init();
    }

    private Init(): void {
        this.Name = StringUtils.Empty;
        this.Description = StringUtils.Empty;
        this.Caption = StringUtils.Empty;
        this.Comments = StringUtils.Empty;
        this.IdentifyingNumber = StringUtils.Empty;
		this.InstallDate = 0;
        this.InstallLocation = StringUtils.Empty;
        this.URLInfoAbout = StringUtils.Empty;
        this.URLUpdateInfo = StringUtils.Empty;
        this.Vendor = StringUtils.Empty;
        this.Version = StringUtils.Empty;

        this.ParentDisplayName = StringUtils.Empty;
        this.ParentKeyName = StringUtils.Empty;
    }

    //public Deserialize(json: Win32_InstalledSoftwareEntryJson): void {
    //    if (json.sw_key !== undefined)
    //        this.Key = json.sw_key;
    //    if (json.name !== undefined)
    //        this.Name = json.name;
    //    if (json.description !== undefined)
    //        this.Description = json.description;
    //    if (json.caption !== undefined)
    //        this.Caption = json.caption;
    //    if (json.comments !== undefined)
    //        this.Comments = json.comments;
    //    if (json.id_number !== undefined)
    //        this.IdentifyingNumber = json.id_number;
    //    if (json.install_date !== undefined)
    //        this.InstallDate = new Date(json.install_date);
    //    if (json.install_location !== undefined)
    //        this.InstallLocation = json.install_location;
    //    if (json.url_info_about !== undefined)
    //        this.URLInfoAbout = json.url_info_about;
    //    if (json.url_update_info !== undefined)
    //        this.URLUpdateInfo = json.url_update_info;
    //    if (json.vendor !== undefined)
    //        this.Vendor = json.vendor;
    //    if (json.version !== undefined)
    //        this.Version = json.version;
    //    if (json.parent_key_name !== undefined)
    //        this.ParentKeyName = json.parent_key_name;
    //    if (json.parent_display_name !== undefined)
    //        this.ParentDisplayName = json.parent_display_name;
    //}

	public Write(obj: any, context: any): void {
		obj.win32_installed_sw_entry = {};
		obj = obj.win32_installed_sw_entry;

		obj.sw_key = this.Key;

		if (this.HasName)
			obj.name = this.Name;
		if (this.HasDescription)
			obj.description = this.Description;
		if (this.HasCaption)
			obj.caption = this.Caption;
		if (this.HasComments)
			obj.comments = this.Comments;
		if (this.HasIdentifyingNumber)
			obj.id_number = this.IdentifyingNumber;
		if (this.HasInstallDate)
			obj.install_date = ValueEncoder.EncodeInteger(this.InstallDate);
		if (this.HasInstallLocation)
			obj.install_location = this.InstallLocation;
		if (this.HasURLInfoAbout)
			obj.url_info_about = this.URLInfoAbout;
		if (this.HasURLUpdateInfo)
			obj.url_update_info = this.URLUpdateInfo;
		if (this.HasVendor)
			obj.vendor = this.Vendor;
		if (this.HasVersion)
			obj.version = this.Version;
		if (this.HasParentKeyName)
			obj.parent_key_name = this.ParentKeyName;
		if (this.HasParentDisplayName)
			obj.parent_display_name = this.ParentDisplayName;
	}

	public Read(obj: any, context: any): void {
		if (!obj.win32_installed_sw_entry)
			throw new Error();
		obj = obj.win32_installed_sw_entry;

        if (obj.sw_key !== undefined)
            this.Key = obj.sw_key;
        if (obj.name !== undefined)
            this.Name = obj.name;
        if (obj.description !== undefined)
            this.Description = obj.description;
        if (obj.caption !== undefined)
            this.Caption = obj.caption;
        if (obj.comments !== undefined)
            this.Comments = obj.comments;
        if (obj.id_number !== undefined)
            this.IdentifyingNumber = obj.id_number;
		if (obj.install_date !== undefined)
			this.InstallDate = ValueEncoder.DecodeInteger(obj.install_date);
        if (obj.install_location !== undefined)
            this.InstallLocation = obj.install_location;
        if (obj.url_info_about !== undefined)
            this.URLInfoAbout = obj.url_info_about;
        if (obj.url_update_info !== undefined)
            this.URLUpdateInfo = obj.url_update_info;
        if (obj.vendor !== undefined)
            this.Vendor = obj.vendor;
        if (obj.version !== undefined)
            this.Version = obj.version;
        if (obj.parent_key_name !== undefined)
            this.ParentKeyName = obj.parent_key_name;
        if (obj.parent_display_name !== undefined)
            this.ParentDisplayName = obj.parent_display_name;
	}

}

export class Win32_InstalledSoftwareTable extends InfoSetTable<string, Win32_InstalledSoftwareEntry> {
    constructor(device: Device) {
        super(device);
    }

    public AddSoftware(softwareKey: string): Win32_InstalledSoftwareEntry {
        var swEntry: Win32_InstalledSoftwareEntry = null;

        if (this._table.ContainsKey(softwareKey)) {
            swEntry = this._table.Item(softwareKey);
        } else {
            swEntry = new Win32_InstalledSoftwareEntry(softwareKey);
            this._table.Add(softwareKey, swEntry);
        }

        return swEntry;
    }

    public AddEntry(swEntry: Win32_InstalledSoftwareEntry): boolean {
        if (!this._table.ContainsKey(swEntry.Key)) {
            this._table.Add(swEntry.Key, swEntry);
            return true;
        }

        return false;
    }

    //public DeserializeEntry(json: Win32_InstalledSoftwareEntryJson): void {
    //    var entry = new Win32_InstalledSoftwareEntry(json.sw_key);
    //    entry.Deserialize(json);
    //    this.AddEntry(entry);
    //}

    //public EntryName(): string {
    //    return "win32_installed_sw_entry";
    //};

    //public static FromJson(json: any, device: Device): Win32_InstalledSoftwareTable {
    //    var result = new Win32_InstalledSoftwareTable(device);
    //    result.Deserialize(json);
    //    return result;
    //}

	public Write(obj: any, context: any): void {
		if (this._table.Count > 0) {
			obj.w32_inst_sw_info = {};
			obj = obj.w32_inst_sw_info;

			obj.entries = [];
			ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_inst_sw_info)
			throw new Error();
		obj = obj.w32_inst_sw_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new Win32_InstalledSoftwareEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}

}
